// extracted by mini-css-extract-plugin
export default {"action-btn":"DirectPromotion--action-btn--PLjOp","actionBtn":"DirectPromotion--action-btn--PLjOp"};